import { render, staticRenderFns } from "./pvscan-carousel.vue?vue&type=template&id=229579a8&scoped=true"
import script from "./pvscan-carousel.vue?vue&type=script&lang=js"
export * from "./pvscan-carousel.vue?vue&type=script&lang=js"
import style0 from "./pvscan-carousel.vue?vue&type=style&index=0&id=229579a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229579a8",
  null
  
)

export default component.exports